export const DEFAULT_CHART_HEIGHT = 220;

export const METRIC_CHART_TAB_CADENCES = {
  WEEKLY: 'wk',
  MONTHLY: 'mth',
  R3M: 'r3m',
  QUARTERLY: 'qtr',
  ANNUAL: 'yr',
};
